import {
  actionsEnum,
  BreifInfluencerV2StatusEnum,
  SORT_ORDER,
} from "@entities/brief/lib/constants";

// import { CampaignBrandCommercials } from "@features/CampaignCommercials/CampaignBrandCommercials";

import classNames from "classnames";

// import { AddCustomFieldsDataButton } from "@features/AddCustomFieldsDataButton";
import { Check, Loader2, Pencil, PenLine, Sparkles, X } from "lucide-react";
import { JSX, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./styles.module.scss";
import { UploadCell, UploadItem } from "./UploadCell";

import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
// import { AddToBucket } from "@features/AddToBucket";
// import BrandCPV from "@features/BrandCPV";
// import BrandPaymentTerms from "@features/BrandPaymentTerms";
import { AddDeliverablesButton } from "@features/CampaignDeliverables/AddDeliverablesButton";
// import ChangePricingPOC from "@features/ChangePricingPOC";
// import { PurchaseInfluencerButton } from "@features/PurchaseInfluencers/PurchaseInfluencerButton";
import { useEditDataFieldV2Data } from "@entities/brief/lib/hooks/useEditDataFieldV2Data";
import { SelectContact } from "@entities/brief/ui/Influencer/v2/SelectContact";
import { NotesCell } from "@entities/brief/ui/NotesCell/NotesCell";
import { useGetDynamicFacets } from "@entities/campaigns/lib/hooks";
import useGetDeliverableConfigurators from "@entities/deliverableConfigurator/lib/hooks/useGetDeliverableConfigurators";
import { DiscoveryService } from "@entities/discovery/lib/services/discovery.service";
import { BrandCommercial } from "@features/brandCommercials/BrandCommercials";
import BrandCPV from "@features/BrandCPV";
import { BriefCreatorColumn } from "@features/breifCreatorColumn/BriefCreatorColumn";
import BriefContactFilterV2 from "@features/BriefContactFilter/BriefContactFilterV2";
import { BriefInfluencerDropDown } from "@features/BriefInfluencerDropDown/BriefInfluencerDropDown";
import { BriefPocFilterV2 } from "@features/briefPocFilter/BriefPocFilterV2";
import CampaignBriefInfluencerDrawer from "@features/CampaignBriefInfluencerDrawer";
import { BriefInfluencerCommercials } from "@features/CampaignCommercialsV2/BriefInfluencerCommercials";
import { CampaignBrandCommercials } from "@features/CampaignCommercialsV2/CampaignBrandCommercials";
import {
  BulkShortlistCreatorsButton,
  ShortlistCreatorButton,
} from "@features/ShortlistCreator";
import { SocialMediaInfluencerComp } from "@features/socialMediaInfluencer/SocialMediaInfluencerComp";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { useTableRowDragSelection } from "@shared/lib/hooks";
import { IPagination } from "@shared/lib/types";
import {
  CustomFieldType,
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerV2,
  IDataFieldValue,
  IFieldConfig,
  IInfluencerContact,
  ISearchFacets,
} from "@shared/lib/types/briefInfluencerV2";
import { formatData } from "@shared/lib/utils/formatData";
import { CreatorContactDetails, Table, TableProps } from "@shared/ui";
import { Button } from "@shared/ui/Button";
import { ColumnFilterWrapper } from "@shared/ui/filters/ColumnFilterWrapper";
import { ColumnSortUI } from "@shared/ui/filters/ColumnSortUI";
import DateRangeFilter from "@shared/ui/filters/DateRangeFilter";
import NumberRangeFilter from "@shared/ui/filters/NumberRangeFilter";
import { SearchMultiSelectFilter } from "@shared/ui/filters/SearchMultiSelectFilter";
import { SelectButton } from "@shared/ui/Select";
import { TextWithTooltip } from "@shared/ui/TextWithTooltip";
import { useQuery } from "@tanstack/react-query";
import {
  getBrandCommercialFilterCount,
  getCampaignBriefStageCounts,
  getInfluencerCommercialFilterCount,
} from "@widgets/CampaignBrief/lib/campaignBriefFilterFacetCounts";
import {
  getAgencyPendingReviewSnippet,
  hasAgencyPendingReview,
} from "@widgets/CampaignBrief/lib/campaignBriefPendingReview";
import {
  CampaignBriefStage,
  getCreatorShortlistActionMode,
} from "@widgets/CampaignBrief/lib/campaignBriefStage";
import { getDynamicColumnSizing } from "@widgets/CampaignBrief/lib/getDynamicColumnSizing";
import { useBriefInfluencerFilterStore } from "@widgets/CampaignBrief/store/useBriefInfluencerFilterStore";
import { CampaignBriefEmptyState } from "@widgets/CampaignBrief/ui/CampaignBriefEmptyState";
import { StatusFilter } from "@widgets/CampaignBrief/ui/CampaignBriefFilters";
import { Drawer, Empty, Flex, Input, InputNumber, Modal, Space } from "antd";
import { Footer } from "antd/es/layout/layout";
import { format } from "date-fns";
import { AiMatchCell } from "./AiMatchCell";
import { BriefAllActions } from "./BriefAllActions";
import { BriefCommercialStatusFilter } from "./BriefCommercialStatusFilter";
import { BriefDeliverablePill } from "./BriefDeliverablePill";
import { BriefInfluencerStatus } from "./BriefInfluencerStatus.tsx";
import { BriefPricingActions } from "./BriefPricingActions";
import { BriefPurchasedActions } from "./BriefPurchasedActions";
import { DeliverableFilter } from "./DeliverableFilter";
import { InfluencerColumnStatusFilter } from "./InfluencerColumnStatusFilter";
import { InfluencerCommercialFilter } from "./InfluencerCommercialFilter";
import { useBriefRowSelection } from "./useBriefRowSelection";

const influencerCommercialOptions = [
  {
    label: "Pending",
    value: "isInfluencerCommercialPending",
  },
  {
    label: "Nego Requested",
    value: "isInfluencerCommercialNegoRequested",
  },
  {
    label: "Received",
    value: "isInfluencerCommercialReceived",
  },
  {
    label: "Nego Received",
    value: "isInfluencerCommercialNegoReceived",
  },
];

const brandCommercialOptions = [
  {
    label: "Pending",
    value: "isPendingQuote",
  },
  {
    label: "Nego Requested",
    value: "isNegotiating",
  },
  {
    label: "Priced",
    value: "isOfferReceived",
  },
];

interface CampaignBriefTableProps {
  updateBriefInfluencer: (id: string, data: IBriefInfluencerV2) => void;
  briefInfluencers: IBriefInfluencerV2[];
  pagination?: IPagination;
  onLoadMore: () => void;
  selectAll: boolean;
  checkedList: string[];
  uncheckList: string[];
  setSelectAll: (value: boolean) => void;
  setCheckedList: (list: string[]) => void;
  setUncheckList: (list: string[]) => void;
  title?: JSX.Element;
  activeStatusFilter: StatusFilter;
  onStatusFilterChange: (filter: StatusFilter) => void;
  onAddCreator: () => void;
  updateBriefInfluencers: (
    data: { id: string; briefInfluencer: IBriefInfluencerV2 }[]
  ) => void;
  isLoadingFirstPage: boolean;
  isLoadingMore: boolean;
  isInAll: boolean;
  debouncedSearchQuery?: string;
  shouldScrollToTop?: boolean;
  onScrollToTopDone?: () => void;
  setSelectedInfluencer: React.Dispatch<
    React.SetStateAction<{
      visible: boolean;
      props?: {
        toOpenInfluencer?: boolean;
        username?: string;
        platform?: string;
        influencerId?: string;
        creatorInfo: {
          name?: string;
          image?: string;
          username?: string;
        };
      };
    }>
  >;
  refetch?: () => void;
  params?: IBriefInfluencerSearchRequestV2;
  searchFacets?: ISearchFacets;
}

export function CampaignBriefTable({
  updateBriefInfluencer,
  briefInfluencers,
  pagination,
  isLoadingFirstPage,
  isLoadingMore,
  onLoadMore,
  selectAll,
  checkedList,
  uncheckList,
  setSelectAll,
  setCheckedList,
  setUncheckList,
  title,
  activeStatusFilter,
  onStatusFilterChange,
  onAddCreator,
  updateBriefInfluencers,
  isInAll,
  debouncedSearchQuery,
  shouldScrollToTop,
  onScrollToTopDone,
  refetch,
  setSelectedInfluencer,
  params,
  searchFacets,
}: CampaignBriefTableProps) {
  const { briefId, brief } = useBriefStore();
  const { deliverableConfiguratorsData } = useGetDeliverableConfigurators();
  const configurators = deliverableConfiguratorsData?.data?.data || [];

  const scrollRef = useRef<HTMLDivElement | null>(null);
  const addCreatorRef = useRef<HTMLDivElement | null>(null);
  const isLoadingRef = useRef(false);

  const [selectedRows, setSelectedRows] = useState<IBriefInfluencerV2[]>([]);
  const checkedListRef = useRef(checkedList);
  const uncheckListRef = useRef(uncheckList);
  const selectedRowsRef = useRef(selectedRows);

  useEffect(() => {
    checkedListRef.current = checkedList;
  }, [checkedList]);

  useEffect(() => {
    uncheckListRef.current = uncheckList;
  }, [uncheckList]);

  useEffect(() => {
    selectedRowsRef.current = selectedRows;
  }, [selectedRows]);

  useEffect(() => {
    if (shouldScrollToTop && scrollRef.current) {
      const bodyEl = scrollRef.current?.querySelector<HTMLDivElement>(
        ".ant-table-tbody-virtual-holder"
      );
      if (bodyEl) {
        bodyEl.scrollTop = 0;
      }
      addCreatorRef?.current?.scrollIntoView({ behavior: "smooth" });
      onScrollToTopDone?.();
    }
  }, [shouldScrollToTop, onScrollToTopDone]);

  const [influencerDrawerProps, setInfluencerDrawerProps] = useState<{
    open: boolean;
    selectedBriefInfluencer?: IBriefInfluencerV2;
  }>({
    open: false,
    selectedBriefInfluencer: undefined,
  });
  const [
    campaignBriefInfluencerDrawerProps,
    setCampaignBriefInfluencerDrawerProps,
  ] = useState<{
    open: boolean;
    briefInfluencerId?: string;
  }>({
    open: false,
    briefInfluencerId: undefined,
  });
  const [highlightedRecordId, setHighlightedRecordId] = useState<string>("");
  const [openDropdownId, setOpenDropdownId] = useState<string | null>(null);

  const [isSelecting, setIsSelecting] = useState(false);
  const [selectionStartIndex, setSelectionStartIndex] = useState<number | null>(
    null
  );

  const {
    beFilters,
    setSortBy,
    setDynamicField,
    setCreatedAtFilter,
    setUpdatedAtFilter,
    setDateColumnSort,
    saveFilters,
    feFilters,
    setFilters,
    resetFilters,
  } = useBriefInfluencerFilterStore();

  useEffect(() => {
    return () => {
      resetFilters();
    };
  }, [resetFilters]);

  useEffect(() => {
    setSelectedRows([]);
  }, [beFilters, debouncedSearchQuery]);

  const hasActiveFilters = useMemo(() => {
    if (debouncedSearchQuery) return true;
    if (!beFilters) return false;

    const hasStatusFilter =
      (beFilters.columnStatusFilters?.length || 0) > 0 ||
      Object.values(beFilters.statusFilters || {}).some(Boolean);
    const hasDeliverables =
      beFilters.delivrables && beFilters.delivrables.length > 0;
    const hasPrimaryContact =
      beFilters.primaryContact &&
      ((beFilters.primaryContact.type &&
        beFilters.primaryContact.type.length > 0) ||
        (beFilters.primaryContact.agencyId &&
          beFilters.primaryContact.agencyId.length > 0));
    const hasDynamicFields =
      beFilters.dynamicFields &&
      Object.keys(beFilters.dynamicFields).length > 0;
    const hasAssignedPricingPoc =
      beFilters.assignedPricingPocV2 &&
      beFilters.assignedPricingPocV2.length > 0;
    const hasSort =
      !!beFilters.sortBy ||
      !!beFilters.sortByCreatedAt ||
      !!beFilters.sortByUpdatedAt;
    const hasCreatedAtFilter =
      !!beFilters.createdAt?.from || !!beFilters.createdAt?.to;
    const hasUpdatedAtFilter =
      !!beFilters.updatedAt?.from || !!beFilters.updatedAt?.to;
    const hasPendingReviewFilter = Boolean(
      params?.pendingReviewActions?.agency &&
      Object.values(params.pendingReviewActions.agency).some(Boolean)
    );
    const hasInfluencerCostDateFilter =
      !!beFilters.influencerCostDate?.from ||
      !!beFilters.influencerCostDate?.to;

    const hasSocialMediaPlatformsFilter =
      beFilters.socialMediaPlatforms &&
      beFilters.socialMediaPlatforms.length > 0;

    return (
      hasStatusFilter ||
      hasDeliverables ||
      hasPrimaryContact ||
      hasDynamicFields ||
      hasAssignedPricingPoc ||
      hasSort ||
      hasCreatedAtFilter ||
      hasUpdatedAtFilter ||
      hasPendingReviewFilter ||
      hasInfluencerCostDateFilter ||
      hasSocialMediaPlatformsFilter
    );
  }, [beFilters, debouncedSearchQuery, params?.pendingReviewActions]);

  const toggleRowSelection = (record: IBriefInfluencerV2) => {
    const rowKey = record._id;
    const isSelected = selectAll
      ? !uncheckList.includes(rowKey)
      : checkedList.includes(rowKey);

    if (isSelected) {
      if (selectAll) {
        setUncheckList([...uncheckList, rowKey]);
        setSelectedRows([...selectedRows, record]);
      } else {
        setCheckedList(checkedList.filter((key) => key !== rowKey));
        setSelectedRows(selectedRows.filter((row) => row._id !== rowKey));
      }
    } else {
      if (selectAll) {
        setUncheckList(uncheckList.filter((key) => key !== rowKey));
      } else {
        setCheckedList([...checkedList, rowKey]);
        setSelectedRows([...selectedRows, record]);
      }
    }
  };

  // const { bulkActions, isBulkActions, isBulkActionsSuccess, bulkActionsError } =
  //   useBulkActions();

  const handleMouseDown = (index: number, event: React.MouseEvent) => {
    const target = event.target as HTMLElement;
    const isCheckbox =
      target.closest(".ant-checkbox") ||
      target.closest(".ant-checkbox-wrapper") ||
      target.closest(".ant-table-selection-column");

    if (!isCheckbox) {
      return;
    }

    if (event.button !== 0) {
      return;
    }

    event.stopPropagation();

    const row = briefInfluencers[index];
    if (!row) return;

    setIsSelecting(true);
    setSelectionStartIndex(index);

    if (selectAll) {
      setUncheckList(uncheckList.filter((key) => key !== row._id));
      return;
    }

    setCheckedList([...checkedList.filter((key) => key !== row._id), row._id]);
    setSelectedRows([
      ...selectedRows.filter((item) => item._id !== row._id),
      row,
    ]);
  };

  const handleMouseMove = useCallback(
    (index: number) => {
      if (
        isSelecting &&
        selectionStartIndex !== null &&
        index >= 0 &&
        index < briefInfluencers.length
      ) {
        const start = Math.min(selectionStartIndex, index);
        const end = Math.max(selectionStartIndex, index);

        const rowsToSelect = briefInfluencers.slice(start, end + 1);
        const keysToSelect = rowsToSelect.map((row) => row._id);

        if (selectAll) {
          setUncheckList(
            uncheckListRef.current.filter((key) => !keysToSelect.includes(key))
          );
          return;
        }

        setCheckedList([
          ...checkedListRef.current.filter(
            (key) => !keysToSelect.includes(key)
          ),
          ...keysToSelect,
        ]);
        setSelectedRows([
          ...selectedRowsRef.current.filter(
            (item) => !rowsToSelect.some((row) => row._id === item._id)
          ),
          ...rowsToSelect,
        ]);
      }
    },
    [
      isSelecting,
      selectionStartIndex,
      briefInfluencers,
      selectAll,
      setCheckedList,
      setUncheckList,
      setSelectedRows,
    ]
  );

  useTableRowDragSelection(briefInfluencers, {
    scrollRootRef: scrollRef,
    isSelecting,
    onSelectRange: handleMouseMove,
  });

  const handleMouseEnterRow = useCallback(
    (index: number) => {
      handleMouseMove(index);
    },
    [handleMouseMove]
  );

  const handleMouseUp = useCallback((event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setIsSelecting(false);
    setSelectionStartIndex(null);
  }, []);

  useEffect(() => {
    if (!isSelecting) return;

    const onDocumentMouseUp = () => {
      setIsSelecting(false);
      setSelectionStartIndex(null);
    };

    document.addEventListener("mouseup", onDocumentMouseUp);
    return () => document.removeEventListener("mouseup", onDocumentMouseUp);
  }, [isSelecting]);

  const hasSelectedRows = selectAll || checkedList.length > 0;
  const stageCounts = getCampaignBriefStageCounts(searchFacets);
  const bulkFilterParams = useMemo(() => {
    if (!params) {
      return {};
    }
    const { limit, ...filterParams } = params;
    return filterParams;
  }, [params]);

  const BriefPricingPOCOptions = [
    ...(searchFacets?.assignedPricingPocV2
      ? searchFacets?.assignedPricingPocV2
      : []),
    {
      _id: "unassigned",
      user: {
        _id: "unassigned",
        firstName: "Unassigned",
        lastName: "",
      },
    },
  ];

  const isDeclined = useCallback((record: IBriefInfluencerV2) => {
    return (
      record.isBrandDeclined ||
      record.isCreatorDeclined ||
      record.status === BreifInfluencerV2StatusEnum.Deleted
    );
  }, []);

  const { editDataField, isEdited, isEditing } =
    useEditDataFieldV2Data(briefId);
  const { userDetails } = useGetMe();
  const [editFieldProps, setEditFieldProps] = useState<{
    briefInfluencerId: string;
    key: string;
    value?: IDataFieldValue;
    fieldType?: CustomFieldType;
    originalValue?: IDataFieldValue;
  }>({
    briefInfluencerId: "",
    key: "",
    value: undefined,
    fieldType: undefined,
    originalValue: undefined,
  });

  useEffect(() => {
    if (!editFieldProps.briefInfluencerId) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setEditFieldProps({
          briefInfluencerId: "",
          key: "",
          value: undefined,
          fieldType: undefined,
          originalValue: undefined,
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [editFieldProps.briefInfluencerId]);

  const [conatcsModalProps, setContactsModalProps] = useState<{
    visible: boolean;
    briefInfluencerId: string;
    conatcts: IInfluencerContact[];
    addContactOnly?: boolean;
    initialContact: IInfluencerContact | null;
    creatorInfo:
      | {
          name: string;
          dp: string;
          rating: number;
        }
      | undefined;
  }>({
    visible: false,
    briefInfluencerId: "",
    creatorInfo: undefined,
    conatcts: [],
    addContactOnly: false,
    initialContact: null,
  });

  const openChangeContact = useCallback(
    (record: IBriefInfluencerV2) => {
      if (
        record?.influencer?.contacts &&
        record?.influencer?.contacts?.length > 0
      ) {
        setContactsModalProps({
          initialContact: record?.primaryContact || null,
          addContactOnly: true,
          visible: true,
          briefInfluencerId: record._id,
          conatcts: record?.influencer?.contacts || [],
          creatorInfo: {
            name: record.socialMedia.username,
            dp: record.socialMedia?.profilePicUrl,
            rating: record.influencer?.avgReview || 0,
          },
        });
        return;
      }

      setSelectedInfluencer({
        visible: true,
        props: {
          influencerId: record?.influencerId || "",
          username: record.socialMedia?.username,
          platform: record.socialMedia?.platform || "",
          creatorInfo: {
            name: record.influencerName,
            image: record.socialMedia?.profilePicUrl,
            username: record.socialMedia?.username,
          },
          toOpenInfluencer: true,
        },
      });
    },
    [setSelectedInfluencer]
  );

  const { dynamicFacets } = useGetDynamicFacets(briefId || "");

  const { data } = useQuery({
    queryKey: ["platforms"],
    queryFn: () => DiscoveryService.getFacets(),
  });
  const platforms = data?.data?.platforms || [];
  const [brandCommercialsModalProps, setBrandluencerModalProps] = useState<{
    visible: boolean;
    briefInfluencer?: IBriefInfluencerV2;
    type: "view" | "create-new" | "create";
  }>({
    visible: false,
    type: "view",
  });

  useEffect(() => {
    setSelectedRows([]);
  }, [activeStatusFilter]);

  const visiblePerformanceFields = useMemo(() => {
    let visibleFields: IFieldConfig[] = [];

    visibleFields = [
      ...visibleFields,
      ...(brief?.dataFieldsV2?.filter((field) => !field.isSpecialField) || []),
    ];
    return visibleFields;
  }, [
    brief?.visibleBrandPerformanceFieldsV2,
    brief?.dataFieldsV2,
    userDetails,
  ]);

  const visibleCustomFields = useMemo(() => {
    let customFields: IFieldConfig[] = [];

    customFields = [
      ...(brief?.visibleBrandCustomFieldsV2 || []),
      ...(brief?.dataFieldsV2?.filter(
        (field) => field.isSpecialField && !field.isShared
      ) || []),
    ];
    return customFields;
  }, [brief?.visibleBrandCustomFieldsV2, brief?.dataFieldsV2, userDetails]);

  const platformsToDisplay = [
    ...platforms.map((item) => ({
      value: item._id,
      label: item._id,
    })),
    { value: "Others", label: "Others" },
  ];

  const columns: TableProps<IBriefInfluencerV2>["columns"] = [
    {
      title: "Creator",
      dataIndex: "influencerName",
      key: "creator",
      fixed: "left",
      width: 210,
      filterCount: beFilters.socialMediaPlatforms?.length || 0,
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered: !!beFilters.socialMediaPlatforms?.length,
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <SearchMultiSelectFilter
            confirm={props.confirm}
            close={props.close}
            options={platformsToDisplay}
            selectedValues={feFilters.socialMediaPlatforms || []}
            onApply={(value) => {
              // console.log("value", value);
              setFilters({
                ...feFilters,
                socialMediaPlatforms: value,
              });
              saveFilters();
            }}
            searchPlaceholder={`Select platform`}
          />
        );
      },
      render: (_: unknown, record: IBriefInfluencerV2) => {
        const shortlistMode = getCreatorShortlistActionMode(
          activeStatusFilter,
          record
        );
        const agencyFlags = record.pendingReviewActions?.agency;
        const notificationText = getAgencyPendingReviewSnippet(agencyFlags);
        return (
          <BriefCreatorColumn
            influencerId={record.influencerId}
            influencerName={record.influencerName}
            username={record.socialMedia?.username}
            platform={record.socialMedia?.platform}
            profilePicUrl={record.socialMedia?.profilePicUrl}
            link={record.socialMedia?.link}
            isCreatorDeclined={record.isCreatorDeclined}
            isBrandDeclined={record.isBrandDeclined}
            creatorDeclinedReason={record.creatorDeclinedReason}
            brandDeclinedReason={record.brandDeclinedReason}
            showStatusTag={false}
            hasNotification={hasAgencyPendingReview(agencyFlags)}
            notificationText={notificationText}
            action={
              shortlistMode ? (
                <ShortlistCreatorButton
                  briefInfluencerId={record._id}
                  mode={shortlistMode}
                />
              ) : undefined
            }
          />
        );
      },
    },

    {
      title: "Contact",
      key: "contact",
      width: 220,
      // hidden: !brief?.visibleBriefTableColumns?.includes("contact"),
      filterCount:
        (beFilters.primaryContact?.type?.length || 0) +
        (beFilters.primaryContact?.agencyId?.length || 0) +
        (beFilters.statusFilters?.isCreatorOnboardingPending ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered: !!(
        (beFilters.primaryContact?.type &&
          beFilters.primaryContact.type.length > 0) ||
        (beFilters.primaryContact?.agencyId &&
          beFilters.primaryContact.agencyId.length > 0) ||
        beFilters.statusFilters?.isCreatorOnboardingPending
      ),
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return <BriefContactFilterV2 {...props} />;
      },
      render: (_, record: IBriefInfluencerV2) => (
        <CreatorContactDetails
          contact={record.primaryContact}
          isContactAdded={record.isPrimaryContactAdded}
          isCompact={false}
        />
      ),
    },
    ...(brief?.isCreatorFitCheckEnabled
      ? [
          {
            title: (
              <span className={styles.aiMatchHeader}>
                Fit Check
                <Sparkles size={12} color="#635bff" />
              </span>
            ),
            key: "aiMatch",
            width: 140,
            sorter: true,
            sortOrder: (beFilters.sortBy?.sortByBriefFitEvalutionScore ===
            SORT_ORDER.ASCEND
              ? "ascend"
              : beFilters.sortBy?.sortByBriefFitEvalutionScore ===
                  SORT_ORDER.DESCEND
                ? "descend"
                : null) as "ascend" | "descend" | null,
            filterCount: beFilters.sortBy?.sortByBriefFitEvalutionScore ? 1 : 0,
            filterDropdownProps: {
              destroyPopupOnHide: true,
            },
            filtered: !!beFilters.sortBy?.sortByBriefFitEvalutionScore,
            filterDropdown: (props: {
              confirm: () => void;
              close: () => void;
            }) => {
              const currentSort =
                beFilters.sortBy?.sortByBriefFitEvalutionScore;
              return (
                <ColumnFilterWrapper
                  title="Fit Check"
                  confirm={props.confirm}
                  close={props.close}
                  hasSort={true}
                  hasFilter={false}
                  sortActive={!!currentSort}
                  sortDirection={
                    currentSort === SORT_ORDER.ASCEND ? "asc" : "desc"
                  }
                  onReset={() => {
                    setSortBy({
                      ...beFilters?.sortBy,
                      sortByBriefFitEvalutionScore: undefined,
                    });
                    saveFilters();
                    props.confirm();
                  }}
                  onApply={() => props.confirm()}
                >
                  <ColumnSortUI
                    sortActive={!!currentSort}
                    sortDirection={
                      currentSort === SORT_ORDER.ASCEND ? "asc" : "desc"
                    }
                    onSortChange={(dir) => {
                      const newSort =
                        dir === "asc"
                          ? SORT_ORDER.ASCEND
                          : dir === "desc"
                            ? SORT_ORDER.DESCEND
                            : undefined;
                      setSortBy({
                        ...beFilters?.sortBy,
                        sortByBriefFitEvalutionScore: newSort,
                      });
                      saveFilters();
                      props.confirm();
                    }}
                    sortAscLabel="Low → high"
                    sortDescLabel="High → low"
                  />
                </ColumnFilterWrapper>
              );
            },
            render: (_: unknown, record: IBriefInfluencerV2) => (
              <AiMatchCell
                record={record}
                updateBriefInfluencer={updateBriefInfluencer}
              />
            ),
          },
        ]
      : []),
    ...[
      ...visiblePerformanceFields.map((field) => {
        const headerText = field.displayName || "";
        const columnValues = briefInfluencers.map((record) => {
          const value = record.dataFields?.[field.key];
          if (!(field.key in (record.dataFields || {}))) return "-";
          if (typeof value === "string") return value;
          if (typeof value === "number")
            return formatData(value, "0.0a") as string;
          return JSON.stringify(value);
        });
        const { width: dynamicWidth, limit: dynamicLimit } =
          getDynamicColumnSizing(headerText, columnValues);
        const isEditingColumn = editFieldProps.key === field.key;

        return {
          title: (
            <TextWithTooltip
              text={headerText}
              limit={dynamicLimit}
              textClassName={styles.metricsHeader}
            />
          ),
          width: Math.max(160, dynamicWidth),
          dataIndex: field.key,
          key: field.key,
          sorter: true,
          sortOrder: (beFilters.sortBy?.sortByDynamicFields?.[field.key] ===
          SORT_ORDER.ASCEND
            ? "ascend"
            : beFilters.sortBy?.sortByDynamicFields?.[field.key] ===
                SORT_ORDER.DESCEND
              ? "descend"
              : null) as "ascend" | "descend" | null,
          filterCount: beFilters.sortBy?.sortByDynamicFields?.[field.key]
            ? 1
            : 0,
          filterDropdownProps: {
            destroyPopupOnHide: true,
          },
          filtered: !!beFilters.sortBy?.sortByDynamicFields?.[field.key],
          filterDropdown: (props: {
            confirm: () => void;
            close: () => void;
          }) => {
            const currentSort =
              beFilters.sortBy?.sortByDynamicFields?.[field.key];
            return (
              <ColumnFilterWrapper
                title={headerText}
                confirm={props.confirm}
                close={props.close}
                hasSort={true}
                hasFilter={false}
                sortActive={!!currentSort}
                sortDirection={
                  currentSort === SORT_ORDER.ASCEND ? "asc" : "desc"
                }
                onReset={() => {
                  const newSortByDynamicFields = {
                    ...beFilters.sortBy?.sortByDynamicFields,
                  };
                  delete newSortByDynamicFields[field.key];
                  setSortBy({
                    ...beFilters?.sortBy,
                    sortByDynamicFields: newSortByDynamicFields,
                  });
                  saveFilters();
                  props.confirm();
                }}
                onApply={() => props.confirm()}
              >
                <ColumnSortUI
                  sortActive={!!currentSort}
                  sortDirection={
                    currentSort === SORT_ORDER.ASCEND ? "asc" : "desc"
                  }
                  onSortChange={(dir) => {
                    const newSort =
                      dir === "asc"
                        ? SORT_ORDER.ASCEND
                        : dir === "desc"
                          ? SORT_ORDER.DESCEND
                          : undefined;
                    const newSortByDynamicFields = {
                      ...beFilters.sortBy?.sortByDynamicFields,
                    };
                    if (newSort === undefined) {
                      delete newSortByDynamicFields[field.key];
                    } else {
                      newSortByDynamicFields[field.key] = newSort;
                    }
                    setSortBy({
                      ...beFilters?.sortBy,
                      sortByDynamicFields: newSortByDynamicFields,
                    });
                    saveFilters();
                    props.confirm();
                  }}
                  sortAscLabel="Low → high"
                  sortDescLabel="High → low"
                />
              </ColumnFilterWrapper>
            );
          },
          render: (_: unknown, record: IBriefInfluencerV2) => {
            const value = record.dataFields?.[field.key];
            const isEditingField =
              editFieldProps.key === field.key &&
              record._id === editFieldProps.briefInfluencerId;

            if (isEditingField) {
              const handleSave = () => {
                editDataField({
                  briefInfluencerId: record._id,
                  dataField: {
                    [editFieldProps.key]: editFieldProps.value ?? "",
                  },
                  handleSuccess: () => {
                    setEditFieldProps({
                      briefInfluencerId: "",
                      key: "",
                      value: undefined,
                      fieldType: undefined,
                      originalValue: undefined,
                    });
                  },
                });
              };

              const handleCancel = () => {
                setEditFieldProps({
                  briefInfluencerId: "",
                  key: "",
                  value: undefined,
                  fieldType: undefined,
                  originalValue: undefined,
                });
              };

              const suffixActions = (
                <Space
                  size={2}
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <Button
                    icon={<Check size={10} />}
                    type="text"
                    size="small"
                    loading={isEditing}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleSave();
                    }}
                    className={styles.editActionButton}
                  />
                  <Button
                    icon={<X size={10} />}
                    type="text"
                    size="small"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleCancel();
                    }}
                    className={styles.editActionButton}
                  />
                </Space>
              );

              const isNumberType =
                field.type === CustomFieldType.NUMBER ||
                typeof value === "number";

              const renderShortcutHint = () => (
                <span className={styles.editShortcutHint}>
                  Enter to save · Esc close
                </span>
              );

              if (isNumberType) {
                return (
                  <div className={styles.editFieldWrapper}>
                    <InputNumber
                      controls={false}
                      style={{ width: "100%" }}
                      value={
                        typeof editFieldProps.value === "number"
                          ? editFieldProps.value
                          : editFieldProps.value
                            ? Number(editFieldProps.value)
                            : undefined
                      }
                      onChange={(val) => {
                        setEditFieldProps({
                          ...editFieldProps,
                          value: val ?? 0,
                        });
                      }}
                      onPressEnter={handleSave}
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation();
                          handleCancel();
                        }
                      }}
                      size="small"
                      className={styles.customFieldInput}
                      suffix={suffixActions}
                      autoFocus
                    />
                    {renderShortcutHint()}
                  </div>
                );
              }

              return (
                <div className={styles.editFieldWrapper}>
                  <Input
                    style={{ width: "100%" }}
                    value={String(editFieldProps.value ?? "")}
                    onChange={(e) => {
                      setEditFieldProps({
                        ...editFieldProps,
                        value: e.target.value,
                      });
                    }}
                    onPressEnter={handleSave}
                    onKeyDown={(e) => {
                      if (e.key === "Escape") {
                        e.stopPropagation();
                        handleCancel();
                      }
                    }}
                    size="small"
                    className={styles.customFieldInput}
                    suffix={suffixActions}
                    autoFocus
                  />
                  {renderShortcutHint()}
                </div>
              );
            }

            const rawDisplay =
              field.key in record.dataFields
                ? typeof value === "string"
                  ? value
                  : typeof value === "number"
                    ? (formatData(value, "0.0a") as string)
                    : JSON.stringify(value)
                : "-";

            const isEmptyValue =
              value === undefined ||
              value === null ||
              value === "" ||
              value === "-" ||
              rawDisplay === "-";

            const displayValue = isEmptyValue ? "Add value" : rawDisplay;

            return (
              <div
                className={classNames(
                  styles.editableCell,
                  isEmptyValue
                    ? styles.editableCellEmpty
                    : styles.editableCellWithValue
                )}
                onClick={(e) => {
                  e.stopPropagation();
                  setEditFieldProps({
                    briefInfluencerId: record._id,
                    key: field.key,
                    value: value as string | number | undefined,
                    fieldType: field.type as CustomFieldType,
                    originalValue: value as string | number | undefined,
                  });
                }}
              >
                <TextWithTooltip
                  textClassName={
                    isEmptyValue ? styles.emptyValueText : styles.metricText
                  }
                  text={displayValue}
                  limit={dynamicLimit}
                />
                <PenLine size={12} className={styles.editIcon} />
              </div>
            );
          },
        };
      }),
      ...visibleCustomFields.map((field) => {
        const headerText = field.displayName || field.key;
        const columnValues =
          field.type === CustomFieldType.UPLOAD
            ? []
            : briefInfluencers.map((record) => {
                const value = record.dataFields?.[field.key];
                if (field.type === "number")
                  return value
                    ? (formatData(Number(value), "0.0a") as string)
                    : "-";
                if (Array.isArray(value)) return value.join(", ");
                return value ? String(value) : "-";
              });
        const { width: dynamicWidth, limit: dynamicLimit } =
          getDynamicColumnSizing(headerText, columnValues);
        const isEditingColumn = editFieldProps.key === field.key;

        const currentSort = beFilters.sortBy?.sortByDynamicFields?.[field.key];
        const isCustomFieldFiltered = !!(
          beFilters?.dynamicFields?.[field.key]?.equalTo?.length ||
          beFilters?.dynamicFields?.[field.key]?.range?.from ||
          beFilters?.dynamicFields?.[field.key]?.range?.to
        );

        const sortUI =
          field.type === "number" ? (
            <ColumnSortUI
              sortActive={!!currentSort}
              sortDirection={currentSort === SORT_ORDER.ASCEND ? "asc" : "desc"}
              onSortChange={(dir) => {
                const newSort =
                  dir === "asc"
                    ? SORT_ORDER.ASCEND
                    : dir === "desc"
                      ? SORT_ORDER.DESCEND
                      : undefined;
                const newSortByDynamicFields = {
                  ...beFilters.sortBy?.sortByDynamicFields,
                };
                if (newSort === undefined) {
                  delete newSortByDynamicFields[field.key];
                } else {
                  newSortByDynamicFields[field.key] = newSort;
                }
                setSortBy({
                  ...beFilters?.sortBy,
                  sortByDynamicFields: newSortByDynamicFields,
                });
                saveFilters();
              }}
              sortAscLabel="Low → high"
              sortDescLabel="High → low"
            />
          ) : undefined;

        return {
          title: (
            <TextWithTooltip
              text={headerText}
              textClassName={styles.metricsHeader}
              limit={dynamicLimit}
            />
          ),
          width: Math.max(160, dynamicWidth),
          dataIndex: field.key,
          key: field.key,
          filterDropdownProps: {
            destroyPopupOnHide: true,
          },
          filtered: isCustomFieldFiltered || !!currentSort,
          filterCount:
            ((beFilters?.dynamicFields?.[field.key] as any)?.equalTo?.length ||
              0) +
            ((beFilters?.dynamicFields?.[field.key] as any)?.range?.from ||
            (beFilters?.dynamicFields?.[field.key] as any)?.range?.to
              ? 1
              : 0) +
            (beFilters.sortBy?.sortByDynamicFields?.[field.key] ? 1 : 0),
          filterDropdown: (props: {
            confirm: () => void;
            close: () => void;
          }) => {
            if (field.type === "string" || field.type === "dropdown") {
              return (
                <SearchMultiSelectFilter
                  confirm={props.confirm}
                  close={props.close}
                  before={sortUI}
                  options={(dynamicFacets?.[field.key] || []).map((item) => ({
                    label: item._id,
                    value: item._id,
                  }))}
                  selectedValues={
                    (
                      beFilters?.dynamicFields?.[field.key] as {
                        equalTo: string[];
                      }
                    )?.equalTo || []
                  }
                  onApply={(value) => {
                    setDynamicField(field.key, value);
                    saveFilters();
                  }}
                  searchPlaceholder={`Search ${field.displayName || field.key}`}
                />
              );
            }

            if (field.type === "number") {
              const currentRange =
                (
                  beFilters?.dynamicFields?.[field.key] as {
                    range: { from?: number; to?: number };
                  }
                )?.range || {};

              return (
                <NumberRangeFilter
                  props={props}
                  before={sortUI}
                  placeholder={`Select ${field.displayName} range`}
                  selectedRange={currentRange}
                  handleRangeChange={(range) => {
                    setDynamicField(field.key, {
                      from: range.from || 0,
                      to: range.to || 0,
                    });
                    saveFilters();
                  }}
                />
              );
            }

            return sortUI ? <div style={{ padding: 4 }}>{sortUI}</div> : null;
          },
          render: (_: unknown, record: IBriefInfluencerV2) => {
            const value = record.dataFields?.[field.key];
            const isEditingField =
              editFieldProps.key === field.key &&
              record._id === editFieldProps.briefInfluencerId;

            if (isEditingField) {
              const handleSave = () => {
                editDataField({
                  briefInfluencerId: record._id,
                  dataField: {
                    [editFieldProps.key]: editFieldProps.value || "",
                  },
                  handleSuccess: (id, briefInfluencer) => {
                    updateBriefInfluencer(id, briefInfluencer);
                    setEditFieldProps({
                      briefInfluencerId: "",
                      key: "",
                      value: undefined,
                      fieldType: undefined,
                      originalValue: undefined,
                    });
                  },
                });
              };

              const handleCancel = () => {
                setEditFieldProps({
                  briefInfluencerId: "",
                  key: "",
                  value: undefined,
                  fieldType: undefined,
                  originalValue: undefined,
                });
              };

              const suffixActions = (
                <Space
                  size={2}
                  onClick={(e) => e.stopPropagation()}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <Button
                    icon={<Check size={10} />}
                    type="text"
                    size="small"
                    loading={isEditing}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleSave();
                    }}
                    className={styles.editActionButton}
                  />
                  <Button
                    icon={<X size={10} />}
                    type="text"
                    size="small"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleCancel();
                    }}
                    className={styles.editActionButton}
                  />
                </Space>
              );

              if (field.type === CustomFieldType.DROPDOWN) {
                const dropdownOptions =
                  field.dropdownOptions?.map((opt) => ({
                    label: opt,
                    value: opt,
                  })) || [];
                const currentValue = Array.isArray(editFieldProps.value)
                  ? editFieldProps.value
                  : editFieldProps.value
                    ? [String(editFieldProps.value)]
                    : [];

                return (
                  <div className={styles.editFieldWrapper}>
                    <SelectButton
                      mode="multiple"
                      value={currentValue}
                      onChange={(val) => {
                        // When Apply is clicked, this is called with final value
                        // When Clear/Cancel is clicked, this is called with empty array
                        const newValue = Array.isArray(val) ? val : [];

                        // Check if this is a cancel (empty value when original had value)
                        const originalValue = editFieldProps.originalValue;
                        const wasOriginalEmpty =
                          !originalValue ||
                          (Array.isArray(originalValue) &&
                            originalValue.length === 0) ||
                          originalValue === "";

                        if (newValue.length === 0 && !wasOriginalEmpty) {
                          // Cancel was clicked - cancel edit mode
                          handleCancel();
                        } else {
                          // Apply was clicked - save the value
                          editDataField({
                            briefInfluencerId: record._id,
                            dataField: {
                              [editFieldProps.key]: newValue,
                            },
                            handleSuccess: (id, briefInfluencer) => {
                              updateBriefInfluencer(id, briefInfluencer);
                            },
                          });
                        }
                      }}
                      options={dropdownOptions}
                      placeholder="Select..."
                      size="small"
                      withFooterActions
                      applyText="Apply"
                      clearText="Cancel"
                      className={styles.customFieldSelect}
                    />
                    <span className={styles.editShortcutHint}>
                      Enter submit · Esc close
                    </span>
                  </div>
                );
              } else if (field.type === "number") {
                return (
                  <div className={styles.editFieldWrapper}>
                    <InputNumber
                      controls={false}
                      style={{ width: "100%" }}
                      value={
                        typeof editFieldProps.value === "number"
                          ? editFieldProps.value
                          : editFieldProps.value
                            ? Number(editFieldProps.value)
                            : undefined
                      }
                      onChange={(val) => {
                        setEditFieldProps({
                          ...editFieldProps,
                          value: val || 0,
                        });
                      }}
                      onPressEnter={handleSave}
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation();
                          handleCancel();
                        }
                      }}
                      size="small"
                      className={styles.customFieldInput}
                      suffix={suffixActions}
                      autoFocus
                    />
                    <span className={styles.editShortcutHint}>
                      Enter submit · Esc close
                    </span>
                  </div>
                );
              } else {
                return (
                  <div className={styles.editFieldWrapper}>
                    <Input
                      style={{ width: "100%" }}
                      value={String(editFieldProps.value || "")}
                      onChange={(e) => {
                        setEditFieldProps({
                          ...editFieldProps,
                          value: e.target.value,
                        });
                      }}
                      onPressEnter={handleSave}
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation();
                          handleCancel();
                        }
                      }}
                      size="small"
                      className={styles.customFieldInput}
                      suffix={suffixActions}
                      autoFocus
                    />
                    <span className={styles.editShortcutHint}>
                      Enter submit · Esc close
                    </span>
                  </div>
                );
              }
            }

            // Not editing: show value and edit icon on hover
            if (field.type === CustomFieldType.UPLOAD) {
              const uploadItems: UploadItem[] =
                Array.isArray(value) &&
                value.every(
                  (item) =>
                    typeof item === "object" &&
                    item !== null &&
                    "url" in item &&
                    "type" in item
                )
                  ? (value as UploadItem[])
                  : [];

              return (
                <UploadCell
                  fieldKey={field.key}
                  briefInfluencerId={record._id}
                  value={uploadItems}
                  onChange={(newItems) => {
                    // Directly save to backend without edit mode
                    editDataField({
                      briefInfluencerId: record._id,
                      dataField: {
                        [field.key]: newItems,
                      },
                      handleSuccess: (id, briefInfluencer) => {
                        updateBriefInfluencer(id, briefInfluencer);
                      },
                    });
                  }}
                />
              );
            }

            const rawDisplay: string =
              field.type === "number"
                ? value
                  ? (formatData(Number(value), "0.0a") as string)
                  : "-"
                : Array.isArray(value)
                  ? value.join(", ")
                  : value
                    ? String(value)
                    : "-";

            const isEmptyValue =
              value === undefined ||
              value === null ||
              value === "" ||
              value === "-" ||
              rawDisplay === "-" ||
              (Array.isArray(value) && value.length === 0);

            const displayValue = isEmptyValue ? "Add value" : rawDisplay;

            return (
              <div
                className={classNames(
                  styles.editableCell,
                  isEmptyValue
                    ? styles.editableCellEmpty
                    : styles.editableCellWithValue
                )}
                onClick={(e) => {
                  e.stopPropagation();
                  setEditFieldProps({
                    briefInfluencerId: record._id,
                    key: field.key,
                    value: value as string | number | string[] | undefined,
                    fieldType: field.type as CustomFieldType,
                    originalValue: value as
                      string | number | string[] | undefined,
                  });
                }}
              >
                <TextWithTooltip
                  text={displayValue}
                  limit={dynamicLimit}
                  textClassName={
                    isEmptyValue
                      ? styles.emptyValueText
                      : styles.customFieldValue
                  }
                />
                <PenLine size={12} className={styles.editIcon} />
              </div>
            );
          },
        };
      }),
    ],
    {
      title: "Pricing POC",
      key: "pricingPoc",
      width: 120,
      filterCount: beFilters.assignedPricingPocV2?.length || 0,
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered: !!beFilters.assignedPricingPocV2?.length,
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefPocFilterV2 {...props} pocOptions={BriefPricingPOCOptions} />
        );
      },
      render: (_, record) => {
        if (record.assignedPricingPocV2) {
          return (
            <Space>
              <span className={styles.pricingNotes}>
                {record.assignedPricingPocV2?.assignedToUser?.firstName}{" "}
                {record.assignedPricingPocV2?.assignedToUser?.lastName}
              </span>
            </Space>
          );
        }
        return <div className={styles.pendingText}> Allocation Pending</div>;
      },
    },

    {
      title: "Deliverables",
      key: "deliverables",
      width: 180,
      filterCount:
        (beFilters.delivrables?.length || 0) +
        (beFilters.statusFilters?.isPendingDeliverables ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered: !!beFilters.delivrables.length,
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return <DeliverableFilter {...props} />;
      },
      render: (_, record) => {
        const hasDeliverableInfo =
          record?.deliverableV2?.name ||
          record?.deliverableV2?.setNumber ||
          (record?.deliverableV2?.purchaseItems?.length ?? 0) > 0 ||
          Boolean(record?.deliverableV2?.notes?.trim());

        return (
          <div className={styles.deliverableCell}>
            {hasDeliverableInfo && record.deliverableV2 ? (
              !isInAll ? (
                <AddDeliverablesButton
                  checkedList={[record._id]}
                  searchPayload={{}}
                  handleUpdateBriefInfluencer={updateBriefInfluencers}
                  buttonProps={{
                    icon: <PenLine size={12} />,
                    type: "text",
                    size: "small",
                    iconPosition: "end",
                    className: styles.deliverableEditButton,
                    onClick: (e) => {
                      e.stopPropagation();
                      setOpenDropdownId((prev) =>
                        prev === record._id ? null : record._id
                      );
                    },
                    children: (
                      <Flex
                        style={{ width: "100%", minWidth: 0 }}
                        align="flex-start"
                        justify="space-between"
                      >
                        <BriefDeliverablePill
                          deliverable={record.deliverableV2}
                          configurators={configurators}
                          showTooltip={
                            openDropdownId === record._id ? false : undefined
                          }
                          showSpecialNotes
                        />
                      </Flex>
                    ),
                  }}
                />
              ) : (
                <BriefDeliverablePill
                  deliverable={record.deliverableV2}
                  configurators={configurators}
                  showSpecialNotes={false}
                />
              )
            ) : (
              <Flex gap={2} align="center">
                <div className={styles.pendingDeliverable}>
                  {!isInAll
                    ? "Deliverables Pending"
                    : "No deliverables Attached"}
                </div>
                {!isInAll ? (
                  <AddDeliverablesButton
                    checkedList={[record._id]}
                    searchPayload={{}}
                    handleUpdateBriefInfluencer={updateBriefInfluencers}
                    buttonProps={{
                      icon: <Pencil size={12} />,
                      type: "text",
                      size: "small",
                      className: styles.deliverableEditButton,
                      children: null,
                    }}
                  />
                ) : null}
              </Flex>
            )}
          </div>
        );
      },
    },

    {
      title: "Influencer Commercials",
      key: "influencerCommercials",
      width: 150,
      filterCount:
        (beFilters.statusFilters?.isInfluencerCommercialPending ? 1 : 0) +
        (beFilters.statusFilters?.isInfluencerCommercialNegoRequested ? 1 : 0) +
        (beFilters.statusFilters?.isInfluencerCommercialReceived ? 1 : 0) +
        (beFilters.statusFilters?.isInfluencerCommercialNegoReceived ? 1 : 0) +
        (beFilters.influencerCostDate?.from || beFilters.influencerCostDate?.to
          ? 1
          : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered:
        beFilters.statusFilters.isInfluencerCommercialPending ||
        beFilters.statusFilters.isInfluencerCommercialNegoRequested ||
        beFilters.statusFilters.isInfluencerCommercialReceived ||
        beFilters.statusFilters.isInfluencerCommercialNegoReceived ||
        !!(
          beFilters.influencerCostDate?.from || beFilters.influencerCostDate?.to
        ),
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <InfluencerCommercialFilter
            {...props}
            options={influencerCommercialOptions}
            getOptionCount={(value) =>
              getInfluencerCommercialFilterCount(searchFacets, value)
            }
            searchPlaceholder="Search influencer commercial status"
          />
        );
      },

      render: (_, record) => {
        return <BriefInfluencerCommercials briefInfluencer={record} />;
      },
    },
    {
      title: "Brand Commercials",
      key: "brandCommercials",
      width: 150,
      filterCount:
        (beFilters.statusFilters?.isPendingQuote ? 1 : 0) +
        (beFilters.statusFilters?.isNegotiating ? 1 : 0) +
        (beFilters.statusFilters?.isOfferReceived ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered:
        beFilters.statusFilters.isPendingQuote ||
        beFilters.statusFilters.isNegotiating ||
        beFilters.statusFilters.isOfferReceived,
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        return (
          <BriefCommercialStatusFilter
            {...props}
            options={brandCommercialOptions}
            getOptionCount={(value) =>
              getBrandCommercialFilterCount(searchFacets, value)
            }
            searchPlaceholder="Search brand commercial status"
          />
        );
      },

      render: (_: any, record: IBriefInfluencerV2, index: number) => {
        return (
          <CampaignBrandCommercials
            campaignInfluencer={record}
            isLastRow={index >= briefInfluencers?.length - 3}
            updateBriefInfluencer={updateBriefInfluencer}
          />
        );
      },
    },

    {
      title: "Brand CPV",
      key: "brandCpv",
      width: 100,
      render: (text: string, record: IBriefInfluencerV2) => {
        return (
          <BrandCPV
            briefInfluencer={record}
            updateBriefInfluencer={updateBriefInfluencer}
          />
        );
      },
    },
    {
      title: "Creator Notes",
      key: "pricingNotes",
      width: 120,
      render: (text: string, record: IBriefInfluencerV2) => {
        return (
          <div
            style={{
              cursor: "pointer",
              width: "100%",
              minHeight: "24px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {record.pricingNotes ? (
              <pre className={styles.pricingNotes} style={{ margin: 0 }}>
                <TextWithTooltip
                  text={record.pricingNotes}
                  limit={100}
                  textClassName={styles.pricingNotes}
                />
              </pre>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      title: "Payment Terms",
      key: "paymentTerms",
      width: 120,
      render: (text: string, record: IBriefInfluencerV2) => {
        return (
          <div
            style={{
              cursor: "pointer",
              width: "100%",
              minHeight: "24px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {record.paymentTerms ? (
              <pre className={styles.pricingNotes} style={{ margin: 0 }}>
                {record.paymentTerms}
              </pre>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },

    {
      title: "Created at",
      dataIndex: "createdAt",
      key: "createdAt",
      hidden: !brief?.visibleBriefTableColumns?.includes("createdAt"),
      width: 120,
      sorter: true,
      sortOrder: (beFilters.sortByCreatedAt === SORT_ORDER.ASCEND
        ? "ascend"
        : beFilters.sortByCreatedAt === SORT_ORDER.DESCEND
          ? "descend"
          : null) as "ascend" | "descend" | null,
      filterCount:
        (beFilters.createdAt?.from || beFilters.createdAt?.to ? 1 : 0) +
        (beFilters.sortByCreatedAt ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered: !!(
        beFilters.createdAt?.from ||
        beFilters.createdAt?.to ||
        beFilters.sortByCreatedAt
      ),
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        const currentSort = beFilters.sortByCreatedAt;

        return (
          <DateRangeFilter
            title="Created at"
            props={props}
            sortActive={!!currentSort}
            sortDirection={currentSort === SORT_ORDER.ASCEND ? "asc" : "desc"}
            onSortChange={(dir) => {
              const newSort =
                dir === "asc"
                  ? SORT_ORDER.ASCEND
                  : dir === "desc"
                    ? SORT_ORDER.DESCEND
                    : undefined;
              setDateColumnSort({
                sortByCreatedAt: newSort,
                sortByUpdatedAt: undefined,
              });
              saveFilters();
            }}
            placeholder="Created at"
            selectedRange={beFilters.createdAt}
            handlePropsChange={(changeProps) => {
              setCreatedAtFilter({
                from: changeProps.range?.from,
                to: changeProps.range?.to,
              });
              saveFilters();
            }}
          />
        );
      },
      render: (createdAt: string) => (
        <span className={styles.pricingNotes}>
          {createdAt ? format(new Date(createdAt), "dd/MM/yyyy") : "—"}
        </span>
      ),
    },
    {
      title: "Updated at",
      dataIndex: "updatedAt",
      key: "updatedAt",
      hidden: !brief?.visibleBriefTableColumns?.includes("updatedAt"),
      width: 120,
      sorter: true,
      sortOrder: (beFilters.sortByUpdatedAt === SORT_ORDER.ASCEND
        ? "ascend"
        : beFilters.sortByUpdatedAt === SORT_ORDER.DESCEND
          ? "descend"
          : null) as "ascend" | "descend" | null,
      filterCount:
        (beFilters.updatedAt?.from || beFilters.updatedAt?.to ? 1 : 0) +
        (beFilters.sortByUpdatedAt ? 1 : 0),
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered: !!(
        beFilters.updatedAt?.from ||
        beFilters.updatedAt?.to ||
        beFilters.sortByUpdatedAt
      ),
      filterDropdown: (props: { confirm: () => void; close: () => void }) => {
        const currentSort = beFilters.sortByUpdatedAt;

        return (
          <DateRangeFilter
            title="Updated at"
            props={props}
            sortActive={!!currentSort}
            sortDirection={currentSort === SORT_ORDER.ASCEND ? "asc" : "desc"}
            onSortChange={(dir) => {
              const newSort =
                dir === "asc"
                  ? SORT_ORDER.ASCEND
                  : dir === "desc"
                    ? SORT_ORDER.DESCEND
                    : undefined;
              setDateColumnSort({
                sortByCreatedAt: undefined,
                sortByUpdatedAt: newSort,
              });
              saveFilters();
            }}
            placeholder="Updated at"
            selectedRange={beFilters.updatedAt}
            handlePropsChange={(changeProps) => {
              setUpdatedAtFilter({
                from: changeProps.range?.from,
                to: changeProps.range?.to,
              });
              saveFilters();
            }}
          />
        );
      },
      render: (updatedAt: string) => (
        <span className={styles.pricingNotes}>
          {updatedAt ? format(new Date(updatedAt), "dd/MM/yyyy") : "—"}
        </span>
      ),
    },
    {
      title: "Status",
      key: "status",
      width: 150,
      fixed: "right" as const,
      align: "right" as const,
      filterCount: beFilters.columnStatusFilters?.length || 0,
      filterDropdownProps: {
        destroyPopupOnHide: true,
      },
      filtered: (beFilters.columnStatusFilters?.length || 0) > 0,
      filterDropdown: (props: { confirm: () => void; close: () => void }) => (
        <InfluencerColumnStatusFilter {...props} searchFacets={searchFacets} />
      ),
      render: (_: unknown, record: IBriefInfluencerV2) => (
        <div className={styles.statusColumn}>
          <div className={styles.statusColumnContent}>
            <BriefInfluencerStatus briefInfluencer={record} />
          </div>
          <div className={styles.statusColumnActions}>
            <BriefInfluencerDropDown
              briefId={record.briefId}
              briefInfluencer={record}
              onChangeContact={() => openChangeContact(record)}
              onView={() =>
                setCampaignBriefInfluencerDrawerProps({
                  open: true,
                  briefInfluencerId: record._id,
                })
              }
              actions={
                record.status === BreifInfluencerV2StatusEnum.Deleted
                  ? [actionsEnum.VIEW]
                  : [
                      actionsEnum.VIEW,
                      ...(record.isPrimaryContactAdded
                        ? [actionsEnum.CHANGE_CONTACT]
                        : []),
                      ...(record.isBrandDeclined || record.isCreatorDeclined
                        ? [actionsEnum.DELETE]
                        : record.status ===
                            BreifInfluencerV2StatusEnum.Purchased
                          ? []
                          : [
                              actionsEnum.BRAND_DECLINED,
                              actionsEnum.CREATOR_DECLINED,
                            ]),

                      // ...(!record.isBrandNewCostPending &&
                      // !record.isNewCommericalRequested &&
                      // record.status !== BreifInfluencerV2StatusEnum.Purchased
                      //   ? [actionsEnum.REQUEST_BRAND_NEGOTIATION]
                      //   : []),
                    ]
              }
            />
          </div>
          {/* <span
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <BriefBrandFavouriteSingle briefInfluencer={record} />
          </span> */}
        </div>
      ),
    },
    ...(isInAll
      ? []
      : [
          {
            title: "Notes",
            key: "notes",
            fixed: "right" as const,
            width: 168,
            render: (_: unknown, record: IBriefInfluencerV2) => (
              <NotesCell record={record} refetch={refetch} />
            ),
          },
        ]),
  ];

  const rowSelection = useBriefRowSelection({
    rows: briefInfluencers,
    totalCount: pagination?.totalCount || 0,
    selectAll,
    checkedList,
    uncheckList,
    setSelectAll,
    setCheckedList,
    setUncheckList,
    selectedRows,
    setSelectedRows,
    hasActiveSearch: Boolean(debouncedSearchQuery?.trim()),
    highlightedRecordId,
  });

  const handleScroll = useCallback(() => {
    const bodyEl = scrollRef.current?.querySelector<HTMLDivElement>(
      ".ant-table-tbody-virtual-holder"
    );
    if (!bodyEl || isLoadingMore || isLoadingRef.current) return;

    const nearBottom =
      bodyEl.scrollTop + bodyEl.clientHeight >= bodyEl.scrollHeight - 120;
    if (nearBottom) {
      isLoadingRef.current = true;
      onLoadMore();
    }
  }, [isLoadingMore, onLoadMore]);

  useEffect(() => {
    if (!isLoadingMore) {
      isLoadingRef.current = false;
    } else {
      isLoadingRef.current = true;
      onLoadMore();
    }
  }, [isLoadingMore]);

  useEffect(() => {
    const body = scrollRef.current?.querySelector<HTMLDivElement>(
      ".ant-table-tbody-virtual-holder"
    );
    if (!body) return;
    body.addEventListener("scroll", handleScroll);
    return () => body.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // Reset edit state on successful edit
  // const clearSelection = useCallback(() => {
  //   setSelectAll(false);
  //   setCheckedList([]);
  //   setUncheckList([]);
  // }, [setSelectAll, setCheckedList, setUncheckList]);

  // useEffect(() => {
  //   if (isBulkActionsSuccess) {
  //     ToastService.success("Influencers declined successfully.");
  //     clearSelection();
  //   } else if (bulkActionsError) {
  //     ToastService.error(bulkActionsError?.message);
  //   }
  // }, [isBulkActionsSuccess, bulkActionsError, clearSelection]);

  // console.log("filters", feFilters, beFilters);

  return (
    <div
      className={styles.tableWrapper}
      ref={scrollRef}
      // style={{ marginBottom: selectRowKeys.length > 0 ? "75px" : "0px" }}
    >
      <Table<IBriefInfluencerV2>
        className={styles.table}
        loading={isLoadingFirstPage}
        // bordered
        rowKey={(record) => record?._id}
        columns={columns}
        dataSource={briefInfluencers}
        onChange={(_pagination, _filters, sorter) => {
          const currentSorter = Array.isArray(sorter) ? sorter[0] : sorter;
          if (
            !currentSorter ||
            !currentSorter.columnKey ||
            !currentSorter.order
          ) {
            setSortBy({});
            setDateColumnSort({
              sortByCreatedAt: undefined,
              sortByUpdatedAt: undefined,
            });
            saveFilters();
            return;
          }

          const key = String(currentSorter.columnKey);
          const order =
            currentSorter.order === "ascend"
              ? SORT_ORDER.ASCEND
              : currentSorter.order === "descend"
                ? SORT_ORDER.DESCEND
                : undefined;

          if (key === "aiMatch") {
            setSortBy({
              ...beFilters?.sortBy,
              sortByBriefFitEvalutionScore: order,
            });
            saveFilters();
          } else if (key === "createdAt") {
            setDateColumnSort({
              sortByCreatedAt: order,
              sortByUpdatedAt: undefined,
            });
            saveFilters();
          } else if (key === "updatedAt") {
            setDateColumnSort({
              sortByCreatedAt: undefined,
              sortByUpdatedAt: order,
            });
            saveFilters();
          } else {
            const newSortByDynamicFields = {
              ...beFilters.sortBy?.sortByDynamicFields,
            };
            if (order === undefined) {
              delete newSortByDynamicFields[key];
            } else {
              newSortByDynamicFields[key] = order;
            }
            setSortBy({
              ...beFilters?.sortBy,
              sortByDynamicFields: newSortByDynamicFields,
            });
            saveFilters();
          }
        }}
        showHeader={
          hasActiveFilters || briefInfluencers?.length > 0 ? true : false
        }
        pagination={false}
        onRow={(record, index) => {
          const actualIndex = briefInfluencers.findIndex(
            (inf) => inf._id === record._id
          );
          const rowIndex = actualIndex >= 0 ? actualIndex : (index ?? 0);

          return {
            "data-row-index": String(rowIndex),
            "data-row-id": record._id,
            onMouseDown: (e) => {
              const target = e.target as HTMLElement;

              if (
                !target.closest("button") &&
                !target.closest("input") &&
                !target.closest(".ant-dropdown") &&
                !target.closest(".ant-select") &&
                !target.closest("a")
              ) {
                // e.stopPropagation();
                handleMouseDown(rowIndex, e);
              }
              // handleMouseDown(rowIndex, e);
            },
            onMouseEnter: () => {
              if (isSelecting) {
                handleMouseEnterRow(rowIndex);
                return;
              }
              setHighlightedRecordId(record._id);
            },
            onMouseMove: () => {
              if (isSelecting) {
                handleMouseMove(rowIndex);
              }
            },
            onMouseUp: (e) => {
              if (isSelecting) {
                e.stopPropagation();
                handleMouseUp(e);
              }
            },
            onMouseLeave: () => {
              if (!isSelecting) {
                setHighlightedRecordId("");
              }
            },
            // onClick: (e) => {
            //   toggleRowSelection(record);
            // },
            style: {
              cursor: isSelecting ? "crosshair" : "default",
              userSelect: isSelecting ? "none" : "auto",
            },
          };
        }}
        scroll={{
          y: selectedRows.length === 0 ? 630 : isLoadingMore ? 560 : 590,
          x: 1000,
        }}
        rowClassName={(record) => {
          return classNames(styles.tableRow, {
            [styles.rowDeclined]:
              isDeclined(record) && !checkedList.includes(record?._id),
            [styles.rowPurchased]:
              record.status === BreifInfluencerV2StatusEnum.Purchased &&
              !checkedList.includes(record?._id),
          });
        }}
        rowSelection={rowSelection}
        virtual
        title={() => (
          <>
            {title}
            {/* {!isInAll && (
              <div className={styles.addCreatorFooter} ref={addCreatorRef}>
                <button
                  onClick={() => {
                    onAddCreator();
                  }}
                  className={styles.addCreatorButton}
                >
                  <div className={styles.addCreatorIcon}>
                    <Plus size={12} strokeWidth={3} />
                  </div>
                  Add Creator
                </button>
              </div>
            )} */}
          </>
        )}
        locale={{
          emptyText:
            isLoadingFirstPage || isInAll ? null : hasActiveFilters ? (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No results found for applied filters"
              />
            ) : (
              <CampaignBriefEmptyState
                activeStatusFilter={activeStatusFilter}
                onStatusFilterChange={onStatusFilterChange}
                onAddCreator={onAddCreator}
                shortlistedCount={stageCounts[CampaignBriefStage.Shortlisted]}
                purchasedCount={stageCounts[CampaignBriefStage.Purchased]}
              />
            ),
        }}
      />

      {isLoadingMore && (
        <Flex justify="center" align="center">
          <div className={styles.loader}>
            <Loader2 size={16} className={styles.loaderIcon} />
            Loading more creators...
          </div>
        </Flex>
      )}
      {hasSelectedRows &&
        createPortal(
          <Footer
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
              background: "white",
              padding: "16px 24px",
              boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Flex
              justify="space-between"
              align="center"
              style={{ overflowX: "auto" }}
            >
              <div>
                <b>
                  {selectAll && uncheckList?.length === 0
                    ? pagination?.totalCount
                    : selectAll && uncheckList?.length > 0
                      ? (pagination?.totalCount || 0) - uncheckList?.length
                      : !selectAll
                        ? checkedList?.length
                        : 0}
                </b>{" "}
                items selected
              </div>
              <Flex gap={10}>
                {activeStatusFilter === CampaignBriefStage.Reviewing && (
                  <>
                    <BriefAllActions
                      selectedRowKeys={checkedList}
                      updateBriefInfluencers={updateBriefInfluencers}
                      visibleCustomFields={visibleCustomFields}
                      setSelectedRowKeys={(prev) => {
                        setCheckedList(prev as string[]);
                      }}
                      selectedRows={selectedRows}
                      setSelectedRows={(prev) => {
                        setSelectedRows(prev as IBriefInfluencerV2[]);
                      }}
                      refetch={refetch}
                      params={params}
                      selectAll={selectAll}
                      uncheckList={uncheckList}
                      setSelectAll={setSelectAll}
                      setUncheckList={setUncheckList}
                      totalCount={pagination?.totalCount}
                      briefInfluencers={briefInfluencers}
                    />
                    <BulkShortlistCreatorsButton
                      mode="shortlist"
                      ids={selectAll ? [] : checkedList}
                      isSelectAll={selectAll}
                      notIncludeIds={selectAll ? uncheckList : []}
                      filterParams={bulkFilterParams}
                    />
                  </>
                )}
                {activeStatusFilter === CampaignBriefStage.Shortlisted && (
                  <>
                    <BulkShortlistCreatorsButton
                      mode="unshortlist"
                      ids={selectAll ? [] : checkedList}
                      isSelectAll={selectAll}
                      notIncludeIds={selectAll ? uncheckList : []}
                      filterParams={bulkFilterParams}
                    />
                    <BriefPricingActions
                      updateBriefInfluencers={updateBriefInfluencers}
                      visibleCustomFields={visibleCustomFields}
                      selectedRowKeys={checkedList}
                      setSelectedRowKeys={(prev) => {
                        setCheckedList(prev as string[]);
                      }}
                      selectedRows={selectedRows}
                      setSelectedRows={(prev) => {
                        setSelectedRows(prev as IBriefInfluencerV2[]);
                      }}
                      refetch={refetch}
                      params={params}
                      selectAll={selectAll}
                      uncheckList={uncheckList}
                      setSelectAll={setSelectAll}
                      setUncheckList={setUncheckList}
                      totalCount={pagination?.totalCount}
                      briefInfluencers={briefInfluencers}
                    />
                  </>
                )}
                {activeStatusFilter === CampaignBriefStage.Purchased && (
                  <BriefPurchasedActions
                    updateBriefInfluencers={updateBriefInfluencers}
                    visibleCustomFields={visibleCustomFields}
                    selectedRowKeys={checkedList}
                    setSelectedRowKeys={(prev) => {
                      setCheckedList(prev as string[]);
                    }}
                    selectedRows={selectedRows}
                    setSelectedRows={(prev) => {
                      setSelectedRows(prev as IBriefInfluencerV2[]);
                    }}
                    refetch={refetch}
                    params={params}
                    selectAll={selectAll}
                    uncheckList={uncheckList}
                    setSelectAll={setSelectAll}
                    setUncheckList={setUncheckList}
                    totalCount={pagination?.totalCount}
                    briefInfluencers={briefInfluencers}
                  />
                )}
              </Flex>
            </Flex>
          </Footer>,
          document.body
        )}

      {/* <Modal
        title={"Edit Deliverable"}
        open={openPackagesProps.open && openPackagesProps.type === "modal"}
        onCancel={() =>
          setOpenPackagesProps({
            open: false,
            selectedBriefInfluencer: undefined,
            type: null,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        <DeliverablePackageCard
          briefId={briefId}
          defaultDeliverableId={brief?.defaultDeliverableV2Id}
          showMarkDefaultButton
          onClose={() =>
            setOpenPackagesProps({
              open: false,
              selectedBriefInfluencer: undefined,
              type: null,
            })
          }
          isEditable={true}
          deliverableId={
            openPackagesProps.selectedBriefInfluencer?.deliverableV2Id
          }
          briefInfluencerIds={[
            openPackagesProps.selectedBriefInfluencer?._id || "",
          ]}
        />
      </Modal> */}

      {/* <Drawer
        open={openPackagesProps.open && openPackagesProps.type === "drawer"}
        onClose={() => {
          setOpenPackagesProps({
            open: false,
            selectedBriefInfluencer: undefined,
            type: null,
          });
          setSelectedDeliverableForAttach(null);
        }}
        title="Campaign Deliverables"
        width={800}
        footer={
          <Flex
            justify="flex-end"
            style={{
              padding: "16px 24px",
              // borderTop: "1px solid #f0f0f0",
              position: "sticky",
              bottom: 0,
              background: "#fff",
              zIndex: 10,
            }}
          >
            <Button
              type="primary"
              disabled={!selectedDeliverableForAttach}
              title={
                selectedDeliverableForAttach
                  ? ""
                  : "Please select a deliverable."
              }
              loading={isAttaching}
              onClick={() => {
                if (
                  selectedDeliverableForAttach &&
                  openPackagesProps.selectedBriefInfluencer?._id
                ) {
                  attachBriefDeliverable({
                    deliverableId: selectedDeliverableForAttach._id,
                    briefInfluencerIds: [
                      openPackagesProps.selectedBriefInfluencer?._id,
                    ],
                  });
                }
              }}
            >
              Attach
            </Button>
          </Flex>
        }
        destroyOnClose
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ width: "100%" }}>
          <CampaignDeliverables
            showTitle={false}
            isEditable={true}
            briefInfluencerIds={[
              openPackagesProps.selectedBriefInfluencer?._id || "",
            ]}
            onClose={() => {
              setOpenPackagesProps({
                open: false,
                selectedBriefInfluencer: undefined,
                type: null,
              });
            }}
            onSelectedDeliverableChange={(deliverable) => {
              setSelectedDeliverableForAttach(
                deliverable ? { _id: deliverable._id || "" } : null
              );
            }}
          />
        </div>
      </Drawer> */}

      <Drawer
        title="Influencer Details"
        open={influencerDrawerProps.open}
        width={1300}
        footer={null}
        destroyOnClose
        onClose={() =>
          setInfluencerDrawerProps({
            open: false,
            selectedBriefInfluencer: undefined,
          })
        }
      >
        {influencerDrawerProps.selectedBriefInfluencer && (
          <SocialMediaInfluencerComp
            creatorInfo={{
              name: influencerDrawerProps.selectedBriefInfluencer
                .influencerName,
              image:
                influencerDrawerProps.selectedBriefInfluencer.socialMedia
                  .profilePicUrl,
              username:
                influencerDrawerProps.selectedBriefInfluencer.socialMedia
                  .username,
            }}
            socialMediaInfluencerReq={
              influencerDrawerProps.selectedBriefInfluencer.socialMedia?._id
                ? {
                    toOpenInfluencer: true,
                    influencerId:
                      influencerDrawerProps.selectedBriefInfluencer
                        .influencerId,
                  }
                : {
                    username: {
                      platform:
                        influencerDrawerProps.selectedBriefInfluencer
                          .socialMedia?.platform || "",
                      socialMediaUsername:
                        influencerDrawerProps.selectedBriefInfluencer
                          .socialMedia?.username || "",
                    },
                    toOpenInfluencer: true,
                  }
            }
          />
        )}
      </Drawer>

      <Modal
        title={"Verify Contact"}
        open={conatcsModalProps.visible}
        onCancel={() =>
          setContactsModalProps({
            visible: false,
            briefInfluencerId: "",
            creatorInfo: undefined,
            conatcts: [],
            initialContact: null,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {conatcsModalProps.visible && conatcsModalProps.creatorInfo && (
          <SelectContact
            initialContact={conatcsModalProps.initialContact}
            briefInfluencerId={conatcsModalProps.briefInfluencerId || ""}
            onSuccess={(briefInfluencer: IBriefInfluencerV2) => {}}
            onClose={() =>
              setContactsModalProps({
                visible: false,
                briefInfluencerId: "",
                creatorInfo: undefined,
                conatcts: [],
                addContactOnly: false,
                initialContact: null,
              })
            }
            creatorInfo={conatcsModalProps.creatorInfo}
          />
        )}
      </Modal>

      <Modal
        title={
          brandCommercialsModalProps.type === "view"
            ? "Edit brand Commericals"
            : brandCommercialsModalProps.type === "create"
              ? "Add new brand Commericals"
              : "Add new brand Commericals"
        }
        open={brandCommercialsModalProps.visible}
        onCancel={() =>
          setBrandluencerModalProps({
            visible: false,
            type: "view",
            briefInfluencer: undefined,
          })
        }
        footer={null}
        width={800}
        destroyOnClose
      >
        {brandCommercialsModalProps.visible &&
          brandCommercialsModalProps.briefInfluencer && (
            <BrandCommercial
              onClose={() =>
                setBrandluencerModalProps({
                  visible: false,
                  type: "view",
                  briefInfluencer: undefined,
                })
              }
              briefInfluencer={brandCommercialsModalProps.briefInfluencer}
              type={brandCommercialsModalProps.type}
            />
          )}
      </Modal>

      <CampaignBriefInfluencerDrawer
        open={campaignBriefInfluencerDrawerProps.open}
        onClose={() =>
          setCampaignBriefInfluencerDrawerProps({
            open: false,
            briefInfluencerId: undefined,
          })
        }
        briefInfluencerId={campaignBriefInfluencerDrawerProps.briefInfluencerId}
      />

      {/* <AddToCampaignFromBrief
        briefId={briefId}
        isInAll={isInAll}
        onClose={() => {
          setOpenAddToCampaignProps({ open: false });
          clearSelection();
        }}
        open={openAddToCampaignProps.open}
        selectedBriefInfluencers={checkedList}
        selectAll={selectAll}
        checkedList={checkedList}
        totalCount={
          selectAll && uncheckList.length === 0
            ? pagination?.totalCount || 0
            : selectAll && uncheckList.length > 0
              ? (pagination?.totalCount || 0) - uncheckList.length
              : checkedList.length
        }
        uncheckList={uncheckList}
        searchPayload={preparePrecheckPayload()}
      />
      <SocialMediaDrawer
        open={influencerDrawerProps.open}
        onClose={() =>
          setInfluencerDrawerProps({
            open: false,
            selectedBriefInfluencer: undefined,
          })
        }
        socialMediaRequest={{
          platform:
            influencerDrawerProps.selectedBriefInfluencer?.socialMedia
              ?.platform || "",
          username:
            influencerDrawerProps.selectedBriefInfluencer?.socialMedia
              ?.username || "",
        }}
      /> */}

      {/* Per-row Popover now renders PricingPOC anchored to the dropdown trigger. */}
    </div>
  );
}
